export const appModes = {
  standard: "standard",
  patientViewHospital: "pvh"
};
